export const iconList = [
  { id: 'kbase-chevron-top', group: 'KBase', alias: 'arrow up' },
  { id: 'kbase-chevron-right', group: 'KBase', alias: 'arrow' },
  { id: 'kbase-chevron-left', group: 'KBase', alias: 'arrow' },
  { id: 'kbase-chevron-bottom', group: 'KBase', alias: 'arrow down' },

  { id: 'kbase-editor-sub', group: 'Editor', alias: 'rich text editor subscript' },
  { id: 'kbase-editor-sup', group: 'Editor', alias: 'rich text editor superscript' },
  { id: 'kbase-editor-expand-block', group: 'Editor', alias: 'accordion' },
  { id: 'kbase-email-alt', group: 'KBase', alias: 'send envelop' },
  { id: 'kbase-editor-ta-c', group: 'Editor', alias: 'rich text editor align center' },
  { id: 'kbase-ask-an-expert', group: 'KBase', alias: 'person question support' },
  { id: 'kbase-megaphone', group: 'KBase', alias: 'horn' },
  { id: 'kbase-products', group: 'KBase', alias: 'pc computer printer' },
  { id: 'kbase-suitcase-alt', group: 'KBase', alias: 'bag portfolio' },
  { id: 'kbase-suitcase', group: 'KBase', alias: 'bag portfolio' },
  { id: 'kbase-full-screen-alt', group: 'KBase', alias: 'image expand filled' },
  { id: 'kbase-full-screen', group: 'KBase', alias: 'image expand' },
  { id: 'kbase-editor-strikethrough', group: 'Editor', alias: 'rich text editor' },
  { id: 'kbase-languages', group: 'KBase', alias: '' },
  { id: 'kbase-print', group: 'KBase', alias: '' },
  { id: 'kbase-ps', group: 'KBase', alias: 'monitor screen' },
  { id: 'kbase-volume-off', group: 'KBase', alias: 'speaker volume disabled mute' },
  { id: 'kbase-volume', group: 'KBase', alias: 'speaker volume' },
  { id: 'kbase-video-record', group: 'KBase', alias: 'camera video recording' },
  { id: 'kbase-video-off', group: 'KBase', alias: 'camera video disabled' },
  { id: 'kbase-video', group: 'KBase', alias: 'camera video' },
  { id: 'kbase-editor-move', group: 'Editor', alias: 'rich text editor arrows' },
  { id: 'kbase-editor-add-button', group: 'Editor', alias: 'rich text editor' },
  { id: 'kbase-editor-add-table', group: 'Editor', alias: 'rich text editor' },
  { id: 'kbase-editor-highlight', group: 'Editor', alias: 'rich text editor' },
  { id: 'kbase-editor-indent-increase', group: 'Editor', alias: 'rich text editor right' },
  { id: 'kbase-editor-indent-decrease', group: 'Editor', alias: 'rich text editor left' },
  { id: 'kbase-editor-eraser', group: 'Editor', alias: 'rich text editor remove' },
  { id: 'kbase-editor-background-color', group: 'Editor', alias: 'rich text editor' },
  { id: 'kbase-editor-font-color', group: 'Editor', alias: 'rich text editor' },
  { id: 'kbase-compress', group: 'KBase', alias: 'arrows collapse shrink' },
  { id: 'kbase-expand', group: 'KBase', alias: 'arrows' },
  { id: 'kbase-send', group: 'KBase', alias: '' },
  { id: 'kbase-image', group: 'KBase', alias: 'file picture' },
  { id: 'kbase-trophy', group: 'KBase', alias: 'cup goblet' },
  { id: 'kbase-paragraph', group: 'KBase', alias: 'text' },
  { id: 'kbase-ppt', group: 'KBase', alias: 'file presentation powerpoint' },
  { id: 'kbase-chat', group: 'KBase', alias: 'message bubbles' },
  { id: 'kbase-user-editor', group: 'KBase', alias: 'person modify' },
  { id: 'kbase-editor-underline', group: 'Editor', alias: 'rich text editor decoration' },
  { id: 'kbase-editor-italic', group: 'Editor', alias: 'rich text editor font style' },
  { id: 'kbase-editor-bold', group: 'Editor', alias: 'rich text editor font weight' },
  { id: 'kbase-editor-blockquote', group: 'Editor', alias: 'bubble' },
  { id: 'kbase-gallery', group: 'KBase', alias: 'file images pictures' },
  { id: 'kbase-editor-columns-2-1', group: 'Editor', alias: 'grid' },
  { id: 'kbase-editor-columns-1-2', group: 'Editor', alias: 'grid' },
  { id: 'kbase-editor-columns-1-1-1', group: 'Editor', alias: 'grid' },
  { id: 'kbase-editor-columns-half', group: 'Editor', alias: 'grid' },
  { id: 'kbase-editor-columns-single', group: 'Editor', alias: 'grid' },
  { id: 'kbase-editor-add-file', group: 'Editor', alias: 'folder plus' },
  { id: 'kbase-home', group: 'KBase', alias: 'root house' },
  { id: 'kbase-facebook', group: 'KBase', alias: 'social' },
  { id: 'kbase-like-alt', group: 'KBase', alias: 'thumb' },
  { id: 'kbase-site-map', group: 'KBase', alias: 'root tree categories folders' },
  { id: 'kbase-arrow-up-down', group: 'KBase', alias: 'top bottom' },
  { id: 'kbase-arrow-left-right', group: 'KBase', alias: '' },
  { id: 'kbase-xls', group: 'KBase', alias: 'file table excel' },
  { id: 'kbase-bell-off', group: 'KBase', alias: 'ring notify disabled' },
  { id: 'kbase-bars-filter', group: 'KBase', alias: '' },
  { id: 'kbase-filter', group: 'KBase', alias: '' },
  { id: 'kbase-article', group: 'KBase', alias: 'file document' },
  { id: 'kbase-audio', group: 'KBase', alias: 'file notes' },
  { id: 'kbase-like', group: 'KBase', alias: 'thumb' },
  { id: 'kbase-dislike', group: 'KBase', alias: 'thumb down' },
  { id: 'kbase-lvl-clock', group: 'Levelup', alias: 'time' },
  { id: 'kbase-lvl-clock-alt', group: 'Levelup', alias: 'time filled' },
  { id: 'kbase-lvl-bookmark', group: 'Levelup', alias: 'add save' },
  { id: 'kbase-bookmark', group: 'KBase', alias: 'add save' },
  { id: 'kbase-bug', group: 'KBase', alias: 'report' },
  { id: 'kbase-bell-alt', group: 'KBase', alias: 'ring notify filled' },
  { id: 'kbase-bell', group: 'KBase', alias: 'ring notify' },
  { id: 'kbase-question-alt', group: 'KBase', alias: 'circle filled' },
  { id: 'kbase-question', group: 'KBase', alias: 'circle' },
  { id: 'kbase-chart', group: 'KBase', alias: 'graph ' },
  { id: 'kbase-globe', group: 'KBase', alias: 'planet earth' },
  { id: 'kbase-history', group: 'KBase', alias: 'revert arrow clock time' },
  { id: 'kbase-buffer', group: 'KBase', alias: 'stack layers' },
  { id: 'kbase-tile-alt', group: 'KBase', alias: 'grid filled' },
  { id: 'kbase-tile', group: 'KBase', alias: 'grid' },
  { id: 'kbase-pushpin-alt', group: 'KBase', alias: 'filled' },
  { id: 'kbase-pushpin', group: 'KBase', alias: '' },
  { id: 'kbase-logout', group: 'KBase', alias: 'arrow exit' },
  { id: 'kbase-undo', group: 'KBase', alias: 'arrow' },
  { id: 'kbase-redo', group: 'KBase', alias: 'arrow' },
  { id: 'kbase-audience', group: 'KBase', alias: 'circle' },
  { id: 'kbase-eye', group: 'KBase', alias: 'show' },
  { id: 'kbase-settings-alt', group: 'KBase', alias: 'gear filled' },
  { id: 'kbase-settings', group: 'KBase', alias: 'gear' },
  { id: 'kbase-calendar', group: 'KBase', alias: 'schedule' },
  { id: 'kbase-send-alt', group: 'KBase', alias: 'filled' },
  { id: 'kbase-save', group: 'KBase', alias: 'floppy disc' },
  { id: 'kbase-info-alt', group: 'KBase', alias: 'filled' },
  { id: 'kbase-info', group: 'KBase', alias: '' },
  { id: 'kbase-reply', group: 'KBase', alias: 'arrow' },
  { id: 'kbase-download', group: 'KBase', alias: 'arrow' },
  { id: 'kbase-external-link', group: 'KBase', alias: 'arrow' },
  { id: 'kbase-link', group: 'KBase', alias: 'chain share' },
  { id: 'kbase-pdf', group: 'KBase', alias: 'file document' },
  { id: 'kbase-folder', group: 'KBase', alias: '' },
  { id: 'kbase-smile', group: 'KBase', alias: 'emote emoji' },
  { id: 'kbase-code', group: 'KBase', alias: 'edit' },
  { id: 'kbase-iframe', group: 'KBase', alias: '' },
  { id: 'kbase-document', group: 'KBase', alias: 'file word' },
  { id: 'kbase-add-document', group: 'KBase', alias: 'file plus' },
  { id: 'kbase-separator', group: 'KBase', alias: 'divider' },
  { id: 'kbase-tags', group: 'KBase', alias: '' },
  { id: 'kbase-copy', group: 'KBase', alias: '' },
  { id: 'kbase-check', group: 'KBase', alias: 'tick' },
  { id: 'kbase-edit', group: 'KBase', alias: 'pen' },
  { id: 'kbase-search', group: 'KBase', alias: 'magnifier' },
  { id: 'kbase-reload', group: 'KBase', alias: 'refresh arrow update' },
  { id: 'kbase-close', group: 'KBase', alias: 'cross' },
  { id: 'kbase-arrow-left', group: 'KBase', alias: '' },
  { id: 'kbase-arrow-bottom', group: 'KBase', alias: 'down' },
  { id: 'kbase-arrow-right', group: 'KBase', alias: '' },
  { id: 'kbase-arrow-top', group: 'KBase', alias: 'up' },
  { id: 'kbase-minus', group: 'KBase', alias: 'remove' },
  { id: 'kbase-add', group: 'KBase', alias: 'plus' },
  { id: 'kbase-lvl-users', group: 'Levelup', alias: 'group' },
  { id: 'kbase-lvl-user', group: 'Levelup', alias: 'person' },
  { id: 'kbase-star-alt', group: 'KBase', alias: 'rating filled' },
  { id: 'kbase-star', group: 'KBase', alias: 'rating' },
  { id: 'kbase-close-circle-alt', group: 'KBase', alias: 'cross filled' },
  { id: 'kbase-close-circle', group: 'KBase', alias: 'cross' },
  {
    id: 'kbase-warning-alt',
    group: 'KBase',
    alias: 'danger exclamation mark sign filled',
  },
  {
    id: 'kbase-warning',
    group: 'KBase',
    alias: 'danger exclamation mark sign',
  },
  { id: 'kbase-check-circle-alt', group: 'KBase', alias: 'tick filled' },
  { id: 'kbase-check-circle', group: 'KBase', alias: 'tick' },
  { id: 'kbase-delete-alt', group: 'KBase', alias: 'remove trash bin filled' },
  { id: 'kbase-delete', group: 'KBase', alias: 'remove trash bin' },
  { id: 'kbase-caret-left', group: 'KBase', alias: 'arrow' },
  { id: 'kbase-caret-down', group: 'KBase', alias: 'arrow bottom' },
  { id: 'kbase-caret-right', group: 'KBase', alias: 'arrow' },
  { id: 'kbase-caret-top', group: 'KBase', alias: 'arrow up' },
  { id: 'kbase-editor-ta-r', group: 'Editor', alias: 'rich text editor align right' },
  { id: 'kbase-editor-ta-l', group: 'Editor', alias: 'rich text editor align left' },
  { id: 'kbase-editor-ta-j', group: 'Editor', alias: 'rich text editor align justify' },
  { id: 'kbase-editor-ul', group: 'Editor', alias: 'rich text editor unordered list' },
  { id: 'kbase-editor-ol', group: 'Editor', alias: 'rich text editor ordered list' },
  { id: 'kbase-image-resolution', group: 'KBase', alias: 'size' },
  { id: 'kbase-dot', group: 'KBase', alias: 'circle' },
  { id: 'kbase-it-self-service', group: 'KBase', alias: 'monitor gear hand' },
  { id: 'kbase-end-user', group: 'KBase', alias: 'person laptop' },
  { id: 'kbase-channel', group: 'KBase', alias: 'person net connections' },
  { id: 'kbase-supplies', group: 'KBase', alias: 'fuel barrel' },
  { id: 'kbase-admin-demo', group: 'KBase', alias: 'folder gear' },
  { id: 'kbase-archive', group: 'KBase', alias: 'remove delete trash bin' },
  { id: 'kbase-personal-systems', group: 'KBase', alias: 'PC laptop' },
  { id: 'kbase-federal', group: 'KBase', alias: 'building' },
  { id: 'kbase-book', group: 'KBase', alias: '' },
  { id: 'kbase-spoc-trash', group: 'Spoc', alias: 'remove delete bin' },
  { id: 'kbase-nakb-menu', group: 'NAKB', alias: 'burger bars' },
  { id: 'kbase-nakb-heart', group: 'NAKB', alias: 'like' },
  { id: 'kbase-nakb-notes', group: 'NAKB', alias: 'document pen' },
  { id: 'kbase-nakb-cat-tree', group: 'NAKB', alias: 'categories folders' },
  { id: 'kbase-nakb-msteams', group: 'NAKB', alias: 'social messenger' },
  {
    id: 'kbase-omni-personalize',
    group: 'Omnicom',
    alias: 'settings customize',
  },
  { id: 'kbase-omni-arrows-left', group: 'Omnicom', alias: 'hide expand' },
  { id: 'kbase-omni-arrows-right', group: 'Omnicom', alias: 'hide expand' },
  { id: 'kbase-spoc-drag', group: 'Spoc', alias: 'drag-n-drop move' },
  { id: 'kbase-spoc-list', group: 'Spoc', alias: '' },
  { id: 'kbase-spoc-sliders', group: 'Spoc', alias: '' },
  { id: 'kbase-lvl-cat-tree', group: 'Levelup', alias: 'categories folders' },
  { id: 'kbase-lvl-download-circle', group: 'Levelup', alias: 'arrow' },
  { id: 'kbase-lvl-upload-circle', group: 'Levelup', alias: 'arrow' },
  { id: 'kbase-lvl-wifi-2', group: 'Levelup', alias: 'signal' },
  { id: 'kbase-lvl-wifi-1', group: 'Levelup', alias: 'signal' },
  { id: 'kbase-lvl-wifi-0', group: 'Levelup', alias: 'signal' },
  { id: 'kbase-lvl-chat-bubble', group: 'Levelup', alias: 'message bubble' },
  { id: 'kbase-lvl-live', group: 'Levelup', alias: 'recording online' },
  { id: 'kbase-lvl-settings-menu', group: 'Levelup', alias: 'menu gear' },
  { id: 'kbase-lvl-upload', group: 'Levelup', alias: 'arrow' },
  { id: 'kbase-omni-third-party-services', group: 'Omnicom', alias: 'connect' },
  { id: 'kbase-lvl-sponsors', group: 'Levelup', alias: 'user person tie' },
  {
    id: 'kbase-lvl-speaker',
    group: 'Levelup',
    alias: 'user person orator broadcaster',
  },
  { id: 'kbase-lvl-support', group: 'Levelup', alias: 'headset headphones' },
  { id: 'kbase-lvl-recording', group: 'Levelup', alias: '' },
  { id: 'kbase-lvl-mic-off', group: 'Levelup', alias: 'microphone disabled' },
  { id: 'kbase-lvl-mic-level-3', group: 'Levelup', alias: 'microphone' },
  { id: 'kbase-lvl-mic-level-2', group: 'Levelup', alias: 'microphone' },
  { id: 'kbase-lvl-mic-level-1', group: 'Levelup', alias: 'microphone' },
  { id: 'kbase-lvl-mic', group: 'Levelup', alias: 'microphone' },
  { id: 'kbase-lvl-menu', group: 'Levelup', alias: '' },
  { id: 'kbase-lvl-lobby', group: 'Levelup', alias: 'door' },
  { id: 'kbase-lvl-heart-full', group: 'Levelup', alias: 'like filled' },
  { id: 'kbase-lvl-heart', group: 'Levelup', alias: 'like' },
  { id: 'kbase-lvl-hand', group: 'Levelup', alias: '' },
  { id: 'kbase-lvl-gift', group: 'Levelup', alias: 'present' },
  {
    id: 'kbase-lvl-faq',
    group: 'Levelup',
    alias: 'frequently asked questions',
  },
  { id: 'kbase-lvl-eye-off', group: 'Levelup', alias: 'show disabled' },
  { id: 'kbase-lvl-eye', group: 'Levelup', alias: 'show' },
  {
    id: 'kbase-lvl-desktop-picture',
    group: 'Levelup',
    alias: 'monitor screen sharing',
  },
  {
    id: 'kbase-lvl-desktop-off',
    group: 'Levelup',
    alias: 'monitor screen disabled',
  },
  { id: 'kbase-lvl-desktop-heart', group: 'Levelup', alias: 'monitor screen' },
  { id: 'kbase-lvl-desktop', group: 'Levelup', alias: 'monitor screen' },
  { id: 'kbase-lvl-cube', group: 'Levelup', alias: 'products' },
  { id: 'kbase-lvl-calendar-clock', group: 'Levelup', alias: 'schedule time' },
  { id: 'kbase-lvl-poll', group: 'Levelup', alias: 'vote ballot' },
  { id: 'kbase-omni-chevron-down', group: 'Omnicom', alias: 'arrow bottom' },
  { id: 'kbase-omni-chevron-up', group: 'Omnicom', alias: 'arrow top' },
  { id: 'kbase-omni-chevron-right', group: 'Omnicom', alias: 'arrow' },
  { id: 'kbase-omni-chevron-left', group: 'Omnicom', alias: 'arrow' },
  { id: 'kbase-omni-double-back', group: 'Omnicom', alias: 'arrow' },
  { id: 'kbase-omni-forward', group: 'Omnicom', alias: 'arrow' },
  { id: 'kbase-omni-headset', group: 'Omnicom', alias: 'headphones' },
  { id: 'kbase-omni-location-pin', group: 'Omnicom', alias: 'mark' },
  { id: 'kbase-omni-mobile', group: 'Omnicom', alias: 'headset cellphone' },
  { id: 'kbase-omni-phone', group: 'Omnicom', alias: 'headset call' },
  { id: 'kbase-omni-text', group: 'Omnicom', alias: 'pen' },
  { id: 'kbase-omni-zoom', group: 'Omnicom', alias: 'social messenger' },
  { id: 'kbase-omni-back', group: 'Omnicom', alias: 'arrow' },
  { id: 'kbase-lvl-session', group: 'Levelup', alias: 'presentation screen' },
  { id: 'kbase-shield', group: 'KBase', alias: 'guard protect' },
  { id: 'kbase-menu-dots', group: 'KBase', alias: 'vertical ellipsis' },
  { id: 'kbase-arrow-right-square', group: 'KBase', alias: 'current' },
  { id: 'kbase-linked-in', group: 'KBase', alias: 'social' },
  { id: 'kbase-twitter', group: 'KBase', alias: 'social' },
  { id: 'kbase-email', group: 'KBase', alias: 'send envelop' },
  { id: 'kbase-skype', group: 'KBase', alias: 'social messenger' },
  { id: 'kbase-tip', group: 'KBase', alias: 'lamp info lightbulb' },

  { id: 'hpicon-telephone2', group: 'HPIcon', alias: '' },
  { id: 'hpicon-ppa', group: 'HPIcon', alias: 'key' },
  { id: 'hpicon-opg', group: 'HPIcon', alias: '' },
  { id: 'hpicon-activations', group: 'HPIcon', alias: 'money' },
  { id: 'hpicon-mobile', group: 'HPIcon', alias: 'phone call' },
  { id: 'hpicon-champion', group: 'HPIcon', alias: 'trophy goblet' },
  { id: 'hpicon-negative-contact-copy', group: 'HPIcon', alias: '' },
  { id: 'hpicon-champion2', group: 'HPIcon', alias: 'stars' },
  { id: 'hpicon-no-contact-copy', group: 'HPIcon', alias: '' },
  { id: 'hpicon-contracts', group: 'HPIcon', alias: 'docs' },
  { id: 'hpicon-dynamics', group: 'HPIcon', alias: '' },
  { id: 'hpicon-email', group: 'HPIcon', alias: 'send envelop' },
  { id: 'hpicon-profiling', group: 'HPIcon', alias: 'card' },
  { id: 'hpicon-flag', group: 'HPIcon', alias: 'person' },
  { id: 'hpicon-saba', group: 'HPIcon', alias: '' },
  { id: 'hpicon-gdpr', group: 'HPIcon', alias: '' },
  { id: 'hpicon-skype', group: 'HPIcon', alias: 'social messenger' },
  { id: 'hpicon-hero', group: 'HPIcon', alias: 'medal' },
  { id: 'hpicon-hp-scout-logo', group: 'HPIcon', alias: '' },
  { id: 'hpicon-strong-contact-copy', group: 'HPIcon', alias: '' },
  { id: 'hpicon-lnr', group: 'HPIcon', alias: 'scales' },
  { id: 'hpicon-telephone', group: 'HPIcon', alias: '' },
  { id: 'hpicon-star', group: 'HPIcon', alias: '' },
  { id: 'hpicon-mild-contact-copy', group: 'HPIcon', alias: '' },
  { id: 'hpicon-envelope', group: 'HPIcon', alias: 'email send' },
  { id: 'hpicon-loyality-gk', group: 'HPIcon', alias: '' },
  { id: 'hpicon-pie-three-quarters', group: 'HPIcon', alias: '' },
  { id: 'hpicon-pie-whole', group: 'HPIcon', alias: '' },
  { id: 'hpicon-pie-quarter', group: 'HPIcon', alias: '' },
  { id: 'hpicon-pie-half', group: 'HPIcon', alias: '' },
  { id: 'hpicon-loyality-co', group: 'HPIcon', alias: '' },
  { id: 'hpicon-loyality-ad', group: 'HPIcon', alias: '' },
  { id: 'hpicon-mindset-mild', group: 'HPIcon', alias: '' },
  { id: 'hpicon-mindset-negative', group: 'HPIcon', alias: '' },
  { id: 'hpicon-mindset-none', group: 'HPIcon', alias: '' },
  { id: 'hpicon-mindset-strong', group: 'HPIcon', alias: '' },
  { id: 'hpicon-progress-0', group: 'HPIcon', alias: '' },
  { id: 'hpicon-progress-25', group: 'HPIcon', alias: '' },
  { id: 'hpicon-progress-50', group: 'HPIcon', alias: '' },
  { id: 'hpicon-progress-75', group: 'HPIcon', alias: '' },
  { id: 'hpicon-progress-100', group: 'HPIcon', alias: '' },
  { id: 'hpicon-loyality-star', group: 'HPIcon', alias: '' },
  { id: 'hpicon-loyality-in', group: 'HPIcon', alias: '' },
  { id: 'hpicon-contact-champion', group: 'HPIcon', alias: 'trophy goblet' },
  { id: 'hpicon-contact-champion2', group: 'HPIcon', alias: 'stars' },
  { id: 'hpicon-contact-hero', group: 'HPIcon', alias: 'medal' },
  { id: 'hpicon-contacts-email', group: 'HPIcon', alias: 'send envelop' },
  { id: 'hpicon-contacts-gdpr', group: 'HPIcon', alias: '' },
  { id: 'hpicon-contacts-pencil', group: 'HPIcon', alias: 'edit' },
  { id: 'hpicon-contacts-phone2', group: 'HPIcon', alias: '' },
  { id: 'hpicon-contacts-ppa', group: 'HPIcon', alias: 'key' },
  { id: 'hpicon-contacts-saba', group: 'HPIcon', alias: 'person' },
  { id: 'hpicon-levels-0', group: 'HPIcon', alias: '' },
  { id: 'hpicon-levels-1', group: 'HPIcon', alias: '' },
  { id: 'hpicon-levels-1-1', group: 'HPIcon', alias: '' },
  { id: 'hpicon-levels-2', group: 'HPIcon', alias: '' },
  { id: 'hpicon-levels-2-1', group: 'HPIcon', alias: '' },
  { id: 'hpicon-other-add-comments', group: 'HPIcon', alias: 'reply arrow' },
  { id: 'hpicon-other-flag', group: 'HPIcon', alias: '' },
  { id: 'hpicon-other-hp-scout-logo', group: 'HPIcon', alias: '' },
  { id: 'hpicon-sat0', group: 'HPIcon', alias: 'emote' },
  { id: 'hpicon-sat1', group: 'HPIcon', alias: 'emote' },
  { id: 'hpicon-sat2', group: 'HPIcon', alias: 'emote' },
  { id: 'hpicon-sat3', group: 'HPIcon', alias: 'emote' },
  { id: 'hpicon-status-profiling', group: 'HPIcon', alias: 'card' },
  { id: 'hpicon-status-opg', group: 'HPIcon', alias: '' },
  { id: 'hpicon-status-lnr', group: 'HPIcon', alias: 'scale' },
  { id: 'hpicon-status-dynamics', group: 'HPIcon', alias: '' },
  { id: 'hpicon-status-contract', group: 'HPIcon', alias: 'docs' },
  { id: 'hpicon-status-call-activity', group: 'HPIcon', alias: 'support headset headphones' },
  { id: 'hpicon-status-activation', group: 'HPIcon', alias: 'money' },
  { id: 'hpicon-social-website', group: 'HPIcon', alias: '' },
  { id: 'hpicon-social-twitter', group: 'HPIcon', alias: '' },
  { id: 'hpicon-social-linkedin', group: 'HPIcon', alias: '' },
  { id: 'hpicon-social-facebook', group: 'HPIcon', alias: '' },
  { id: 'hpicon-sat5', group: 'HPIcon', alias: 'emote' },
  { id: 'hpicon-sat4', group: 'HPIcon', alias: 'emote' },
  { id: 'hpicon-top-50', group: 'HPIcon', alias: '' },
  { id: 'hpicon-top-100', group: 'HPIcon', alias: '' },
  { id: 'hpicon-top-200', group: 'HPIcon', alias: '' },
  { id: 'hpicon-top-nfb', group: 'HPIcon', alias: '' },
  { id: 'hpicon-user-email', group: 'HPIcon', alias: 'send envelop' },
  { id: 'hpicon-user-mobile', group: 'HPIcon', alias: 'phone' },
  { id: 'hpicon-user-phone', group: 'HPIcon', alias: '' },
  { id: 'hpicon-user-skype', group: 'HPIcon', alias: 'social messenger' },
  { id: 'hpicon-ellipsis-v', group: 'HPIcon', alias: 'menu dots' },
  { id: 'hpicon-list', group: 'HPIcon', alias: '' },
  { id: 'hpicon-th', group: 'HPIcon', alias: 'table cards' },
  { id: 'hpicon-fb', group: 'HPIcon', alias: '' },
  { id: 'hpicon-swords', group: 'HPIcon', alias: '' },
  { id: 'hpicon-top-fb', group: 'HPIcon', alias: '' },
  { id: 'hpicon-enroll', group: 'HPIcon', alias: 'edit pen' },
  { id: 'hpicon-add-contact', group: 'HPIcon', alias: ' person' },
  { id: 'hpicon-multi-gear', group: 'HPIcon', alias: 'settings' },
  { id: 'hpicon-magnifying-glass', group: 'HPIcon', alias: 'search' },
  { id: 'hpicon-projection-screen', group: 'HPIcon', alias: '' },
  { id: 'hpicon-table', group: 'HPIcon', alias: '' },
]
